import * as React from 'react'
import { CompoundButton, IOverflowSetItemProps, Stack, StackItem } from '@fluentui/react'
import { useHistory } from 'react-router-dom'

type Props = {
    items: IActionButton[]
    horizontal: boolean
}

export interface IActionButton extends IOverflowSetItemProps {
    key: string
    title?: string
    iconName?: string
    iconOnly?: boolean
    route?: string
    filter?: () => boolean
    isDisabled?: () => boolean
    element?: (props: IOverflowSetItemProps) => React.ReactNode
    onClick?: (event: React.MouseEvent<CompoundButton>) => void
}

export default function ActionButtons(props: Props) {
    const history = useHistory()
    return (
        <Stack grow tokens={{ childrenGap: 's1' }} horizontal={props.horizontal} className="action-buttons">
            {props.items
                .filter((item: IActionButton) => !item.filter || item.filter())
                .map((item: IActionButton) => ({
                    ...item,
                    disabled: (() => {
                        if (item.isDisabled !== undefined) {
                            return item.isDisabled()
                        } else if (item.disabled !== undefined) {
                            return item.disabled
                        }
                        return false
                    })(),
                }))
                .map((item: IActionButton) => (
                    <StackItem key={item.key}>
                        {item.element ? (
                            item.element(item)
                        ) : (
                            <CompoundButton
                                primary
                                {...item}
                                iconProps={item.iconName && { iconName: item.iconName }}
                                onClick={item.route ? () => history.push(item.route) : item.onClick}
                            >
                                {!item.iconOnly && item.title}
                            </CompoundButton>
                        )}
                    </StackItem>
                ))}
        </Stack>
    )
}
